import { Theme } from '@mui/material/styles';

export const description = {
    display: 'block',
    lineHeight: 1.5,
    textAlign: 'justify',
} as const;

export const accordion = (theme: Theme) => ({
    marginTop: `${theme.spacing(1.25)} !important`,
    marginBottom: `${theme.spacing(4.375)} !important`,
}) as const;

export const summary = {
    padding: 0,
    color: 'primary.main',
} as const;

export const details = {
    padding: 0,
    color: 'text.secondary',
} as const;

export const info = (theme: Theme) => ({
    marginBottom: theme.spacing(2),
    fontSize: 12,
    textAlign: 'justify',
}) as const;

export const link = {
    marginBottom: 0,
    fontSize: 12,
} as const;

export const caption = (theme: Theme) => ({
    marginY: theme.spacing(2),
}) as const;

export const divider = (theme: Theme) => ({
    marginBottom: theme.spacing(2),
}) as const;
